import moment from 'moment';
var dateUtility = {};
dateUtility.dateToString = function (date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
  return date ? moment.parseZone(date).format(format) : '';
};
export default dateUtility;